import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import { shouldForwardProp } from '@ori/presentation-utils';
import { keyframes, styled } from '@ori-ui/mui';
import { getDotSize, getRectangleWidth } from "../utils";
var loading = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  100% {\n    background-position: left;\n  }\n"])));
export var PaginationRoot = styled('div')({
  bottom: '15px',
  display: 'table',
  height: '17px',
  left: '0',
  position: 'absolute',
  textAlign: 'center',
  width: '100%'
});
export var PaginationStepRoot = styled('span', {
  shouldForwardProp: shouldForwardProp()
})(function (_ref) {
  var autoplay = _ref.autoplay,
    hidden = _ref.hidden,
    isActive = _ref.isActive,
    isNext = _ref.isNext,
    isPrevious = _ref.isPrevious,
    pagination = _ref.pagination,
    theme = _ref.theme;
  var style = {
    background: isActive ? theme.palette.blueGrey['300'] : theme.palette.grey.A200,
    borderRadius: '50%',
    cursor: isActive ? 'default' : 'pointer',
    display: hidden ? 'none' : 'inline-block',
    height: getDotSize({
      isActive: isActive,
      isNext: isNext,
      isPrevious: isPrevious
    }),
    margin: theme.spacing(0, 1),
    opacity: '1',
    transition: 'background 300ms, width 300ms, height 300ms',
    verticalAlign: 'middle',
    width: getDotSize({
      isActive: isActive,
      isNext: isNext,
      isPrevious: isPrevious
    }),
    '&:hover': {
      animation: 'none'
    }
  };
  if ((pagination === null || pagination === void 0 ? void 0 : pagination.style) === 'rectangles') {
    style.background = isActive ? theme.palette.common.white : 'rgba(255, 255, 255, 0.1)';
    style.backdropFilter = 'blur(20px) brightness(106%)';
    style.borderRadius = '900px';
    style.height = '6px';
    style.width = getRectangleWidth({
      isNext: isNext,
      isPrevious: isPrevious
    });
  }
  if (autoplay !== null && autoplay !== void 0 && autoplay.enabled && isActive) {
    var _autoplay$interval;
    style.animation = "".concat(loading, " ").concat((_autoplay$interval = autoplay.interval) !== null && _autoplay$interval !== void 0 ? _autoplay$interval : 0, "ms 0s forwards linear");
    style.backgroundSize = '200% 100%';
    style.backgroundPosition = 'right';
    style.transition = 'width 300ms, height 300ms';
    if ((pagination === null || pagination === void 0 ? void 0 : pagination.style) === 'dots') {
      style.background = "linear-gradient(to right, ".concat(theme.palette.blueGrey['300'], " 50%, ").concat(theme.palette.grey.A200, " 0)");
      style.borderRadius = '5px';
      style.height = getDotSize();
      style.width = '20px';
    }
    if ((pagination === null || pagination === void 0 ? void 0 : pagination.style) === 'rectangles') {
      style.background = "linear-gradient(to right, ".concat(theme.palette.common.white, " 50%, rgba(255, 255, 255, 0.1) 0)");
    }
  }
  return style;
});
//# sourceMappingURL=pagination.js.map